import { getSupabaseClient } from "../providers/supabase/supabase";
import type { GulaClient } from "./gulaTypes";

export type LeadDecision = "keep" | "release" | "reactivate";

/** Keeps, releases or sends a lead to "Reactivar" (owner or admin only). */
export const decideLead = async (
  client: GulaClient,
  action: LeadDecision,
  reason?: string,
): Promise<void> => {
  const { error } = await getSupabaseClient().rpc("gula_lead_decision", {
    p_client_id: Number(client.id),
    p_action: action,
    p_reason: reason ?? null,
  });
  if (error) throw new Error(error.message);
};
